// extracted by mini-css-extract-plugin
export var container = "Switcher-module--container--0c8ca";
export var switcher = "Switcher-module--switcher--763cf";
export var label = "Switcher-module--label--f02fc";
export var input = "Switcher-module--input--afb04";